module.exports = __webpack_public_path__ + "static/img/问医生@3x.a5f3d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/问医生@3x.png
// module id = 792
// module chunks = 382